document.addEventListener("DOMContentLoaded", function () {
  const texts = [
    "💫 Amazing Star Map Personalisation Options!",
    "🚚 Excellent Service - Fast & FREE Shipping!",
    "✨ Printed on 260 gsm Photo Lustre paper for a beautiful finish!",
    "Free Framing Service 🖼️ Frames in - Classic Black, Elegant White and Natural Wood Brown.",
    "🎁 Ribbon Gift Wrap - various colours available - see more at checkout!",
    "👀 Starting from £21.99!"
  ];

  const highlightColor = '#FFB503';
  const targetEl = document.getElementById("type-js");
  let currentTextIndex = 0;
  let letterIndex = 0;
  let typingSpeed = 100; // Reduced randomness for better consistency

  function typeText() {
    if (!targetEl) return;

    if (letterIndex === 0) {
      targetEl.style.backgroundColor = highlightColor;
      setTimeout(() => {
        targetEl.innerHTML = '';
        targetEl.style.backgroundColor = 'rgba(0,0,0,0)';
        requestAnimationFrame(typeNextChar);
      }, 300); // Slightly lower initial delay
    } else {
      requestAnimationFrame(typeNextChar);
    }
  }

  function typeNextChar() {
    if (letterIndex < texts[currentTextIndex].length) {
      targetEl.innerHTML += texts[currentTextIndex].charAt(letterIndex);
      letterIndex++;
      setTimeout(typeText, typingSpeed);
    } else {
      currentTextIndex = (currentTextIndex + 1) % texts.length;
      letterIndex = 0;
      setTimeout(typeText, 1500); // Pause before switching to the next text
    }
  }

  typeText();
});
